import { render, staticRenderFns } from "./HUDNavigator.vue?vue&type=template&id=df435f72&scoped=true&"
import script from "./HUDNavigator.vue?vue&type=script&lang=ts&"
export * from "./HUDNavigator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df435f72",
  null
  
)

export default component.exports